import React from 'react';

import type { UserDto } from '../../../api/types';
import { InvitedUsersList } from '../../../features/selection/InvitedUsersList';
import type { AuthUser } from '../../../store/slices/authSlice';

export type EventInviteSectionProps = {
  invitedUsers: UserDto[];
  isSubmitting: boolean;
  onOpenMemberModal: () => void;
  onOpenGroupModal: () => void;
  onRemoveUser: (telegramId: string) => void;
  reservedSlotsCount?: number;
  currentUser?: AuthUser | null;
  onAddReservedSlot?: () => void;
  onRemoveReservedSlot?: () => void;
};

export const EventInviteSection = React.memo(function EventInviteSection({
  invitedUsers,
  isSubmitting,
  onOpenMemberModal,
  onOpenGroupModal,
  onRemoveUser,
  reservedSlotsCount,
  currentUser,
  onAddReservedSlot,
  onRemoveReservedSlot,
}: EventInviteSectionProps) {
  return (
    <div className="ttbFormSection">
      <div className="ttbFormSectionHeader">
        <span className="ttbFormSectionIcon">👥</span>
        <h2 className="ttbFormSectionTitle">Пригласить участников</h2>
      </div>

      <div className="ttbFieldHint ttbInviteHint">
        Вы можете пригласить участников или отряды заранее
      </div>

      <div className="ttbInviteButtons">
        {onAddReservedSlot && (
          <button
            type="button"
            onClick={onAddReservedSlot}
            disabled={isSubmitting}
            className="ttbButton ttbButtonOutlineHeader ttbInviteButton ttbInviteButton--reserve"
          >
            {'\uD83D\uDD12'} Забронировать место
          </button>
        )}
        <div className="ttbInviteButtonsRow">
          <button
            type="button"
            onClick={onOpenMemberModal}
            disabled={isSubmitting}
            className="ttbButton ttbButtonOutlineHeader ttbInviteButton"
          >
            ➕ Пригласить участника
          </button>
          <button
            type="button"
            onClick={onOpenGroupModal}
            disabled={isSubmitting}
            className="ttbButton ttbButtonOutlineHeader ttbInviteButton"
          >
            ⚔️ Пригласить отряд
          </button>
        </div>
      </div>

      <InvitedUsersList
        users={invitedUsers}
        onRemove={onRemoveUser}
        reservedSlotsCount={reservedSlotsCount}
        currentUser={currentUser}
        onRemoveReservedSlot={onRemoveReservedSlot}
      />
    </div>
  );
});
